<template>
  <!--
      作者：kmdshop
      时间：2020-06-01
      描述：插件中心-用户房产-编辑
    -->
    <el-dialog
    title="编辑用户房产"
    :visible.sync="dialogVisible"
    @close="dialogFormVisible"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    width="70%"
  >

  <div class="product-add pb50">

    <el-form size="small" :model="form" ref="form" :rules="rules" label-width="120px">
      <div class="common-form">编辑用户房产</div>

      <!-- 选择用户 -->
      <el-form-item label="选择用户" :rules="[{required: true,message: '请选择用户'}]">
        <div class="d-s-s d-c">
          <el-button @click="openUser" icon="el-icon-plus">选择用户</el-button>
          <ul class="d-s-s select-user">
            <li v-if="user.user_id" class="mr10 d-c-c d-c p-10-0">
              <img :src="user.avatarUrl || '/static/images/default_avatar.png'" class="radius" width="30" height="30" />
              <p class="lh18 ww100 text-ellipsis">{{user.nickName}} ({{user.mobile}})</p>
            </li>
          </ul>
        </div>
      </el-form-item>

      <!-- 选择房产 -->
      <el-form-item label="选择房产" prop="real_estate_id">
        <el-select v-model="form.real_estate_id" placeholder="请选择房产" class="max-w460" @change="onRealEstateChange">
          <el-option 
            v-for="item in realEstateList" 
            :key="item.real_estate_id" 
            :label="item.name" 
            :value="item.real_estate_id">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="楼层" prop="floor_number">
        <el-input v-model="form.floor_number" placeholder="请输入房号" class="max-w460"></el-input>
      </el-form-item>
      <!-- 房号 -->
      <el-form-item label="房号" prop="room_number">
        <el-input v-model="form.room_number" placeholder="请输入房号" class="max-w460"></el-input>
      </el-form-item>

      <!-- 业主信息 -->
      <el-form-item label="业主信息">
        <div class="owner-info-container">
          <el-form-item label="业主姓名" prop="owner_name" class="owner-info-item">
            <el-input v-model="form.owner_name" placeholder="请输入业主姓名" class="max-w200"></el-input>
          </el-form-item>
          <el-form-item label="手机号码" prop="owner_phone" class="owner-info-item">
            <el-input v-model="form.owner_phone" placeholder="请输入手机号码" class="max-w200"></el-input>
          </el-form-item>
          <!-- <el-form-item label="身份证号" prop="owner_id_card" class="owner-info-item">
            <el-input v-model="form.owner_id_card" placeholder="请输入身份证号码" class="max-w300"></el-input>
          </el-form-item> -->
        </div>
      </el-form-item>

      <!-- 证明材料 -->
      <el-form-item label="证明材料">
        <div class="proof-container">
          <el-form-item label="工作证照片" prop="property_certificate">
            <div class="draggable-list">
              <draggable class="wrapper" v-model="form.property_certificate">
                <transition-group>
                  <div v-for="(item, index) in form.property_certificate" :key="item.file_path">
                    <div class="item">
                      <img v-img-url="item.file_path" alt="工作证"/>
                      <a href="javascript:void(0);" class="delete-btn" @click.stop="deleteImg(index,'property_certificate')"><i class="el-icon-close"></i></a>
                    </div>
                  </div>
                </transition-group>
              </draggable>
              <div class="item img-select" @click="openProductUpload('property_certificate')">
                <i class="el-icon-plus"></i>
              </div>
            </div>
            <div class="tip-text">请上传清晰的房产证照片</div>
          </el-form-item>

          <el-form-item label="缴费单照片" prop="payment_receipt">
            <div class="draggable-list">
              <draggable class="wrapper" v-model="form.payment_receipt">
                <transition-group>
                  <div v-for="(item, index) in form.payment_receipt" :key="item.file_path">
                    <div class="item">
                      <img v-img-url="item.file_path" alt="缴费单"/>
                      <a href="javascript:void(0);" class="delete-btn" @click.stop="deleteImg(index,'payment_receipt')"><i class="el-icon-close"></i></a>
                    </div>
                  </div>
                </transition-group>
              </draggable>
              <div class="item img-select" @click="openProductUpload('payment_receipt')">
                <i class="el-icon-plus"></i>
              </div>
            </div>
            <div class="tip-text">请上传近期的物业缴费单</div>
          </el-form-item>
        </div>
      </el-form-item>

      <!-- 权限管理 -->
      <el-form-item label="权限管理">
        <div class="permission-container">
         <el-checkbox v-model="propertyPermission">物业权限</el-checkbox>
  <el-checkbox v-model="waterPermission">水费权限</el-checkbox>
  <el-checkbox v-model="electricPermission">电费权限</el-checkbox>
  <el-checkbox v-model="parkingPermission">车位费权限</el-checkbox>
        </div>
        <div class="tip-text">请勾选需要开通的缴费权限</div>
      </el-form-item>

      <!-- 申请备注 -->
      <el-form-item label="申请备注" prop="apply_remark">
        <el-input
          type="textarea"
          :rows="3"
          v-model="form.apply_remark"
          placeholder="请输入申请备注信息（选填）"
          class="max-w460">
        </el-input>
        <div class="word-count">{{form.apply_remark.length}}/200</div>
      </el-form-item>
       
      <!--提交-->
      <div class="common-button-wrapper">
        <el-button size="small" type="info" @click="cancelFunc">取消</el-button>
        <el-button size="small" type="primary" @click="onSubmit" :loading="loading">提交申请</el-button>
      </div>
    </el-form>
    
    <!-- 图片上传组件 -->
    <Upload v-if="isProductUpload" :config="{ total: 5 }" :isupload="isProductUpload" @returnImgs="returnProductImgsFunc">上传图片
    </Upload>
    
    <!-- 选择用户组件 -->
    <UserSelect :is_open="isOpenUser" :multi="false" @close="closeUserFunc"></UserSelect>
  </div>
</el-dialog>
</template>

<script>
import Fc_userApi from '@/api/fc_user.js';
import RealEstateApi from '@/api/real_estate.js'; // 引入房产API
import Upload from '@/components/file/Upload';
import UserSelect from '@/components/user/Select.vue'; // 用户选择组件
import draggable from "vuedraggable";
export default {
  components: {
     /*图片上传*/
     Upload,
     UserSelect,
     draggable
  },
  data() {
    return {
        isupload: false,
      isImg: false,  
      /*form表单数据*/
      form: {
        user_id: 0,
        real_estate_id: '',
        room_number: '',
        floor_number:'',
        owner_name: '',
        owner_phone: '',
        // owner_id_card: '',
        property_certificate: [], // 工作证照片
        payment_receipt: [], // 缴费单照片
        apply_remark: '', // 申请备注
        property_permission: 0, // 物业权限，默认开启
        water_permission: 0, // 水费权限，默认开启
        electric_permission: 0, // 电费权限，默认开启
        parking_permission: 0 // 车位费权限，默认关闭
      },
      // 用户信息
      user: {},
      // 房产列表
      realEstateList: [],
      loading: false,
      /*验证规则*/
      rules: {
        real_estate_id: [{ required: true, message: '请选择房产', trigger: 'change' }],
        floor_number: [{ required: true, message: '请输入楼层', trigger: 'blur' }],
        room_number: [{ required: true, message: '请输入房号', trigger: 'blur' }],
        owner_name: [{ required: true, message: '请输入业主姓名', trigger: 'blur' }],
      },
      dialogVisible: false,
      isProductUpload: false,
      code: "", // 当前上传的图片类型
      // 选择用户开关
      isOpenUser: false
    };
  },
  created() {
    this.dialogVisible = this.open_add;
    this.getDetail();
  },
  props: ["open_add","fc_user_id"],
   computed: {
    propertyPermission: {
      get() {
        return this.form.property_permission === 1;
      },
      set(value) {
        this.form.property_permission = value ? 1 : 0;
      }
    },
    waterPermission: {
      get() {
        return this.form.water_permission === 1;
      },
      set(value) {
        this.form.water_permission = value ? 1 : 0;
      }
    },
    electricPermission: {
      get() {
        return this.form.electric_permission === 1;
      },
      set(value) {
        this.form.electric_permission = value ? 1 : 0;
      }
    },
    parkingPermission: {
      get() {
        return this.form.parking_permission === 1;
      },
      set(value) {
        this.form.parking_permission = value ? 1 : 0;
      }
    }
  },
  methods: {
    getRealEstateList() {
      let self = this;
      RealEstateApi.list({}, true)
        .then(data => {
          self.realEstateList = data.data.list.data || [];
        })
        .catch(error => {
          console.error('获取房产列表失败:', error);
        });
    },
    
    /*打开选择用户*/
    openUser() {
      this.isOpenUser = true;
    },
    
    /*关闭选择用户*/
    /*关闭选择用户*/
closeUserFunc(e) {
  // UserSelect组件应该返回一个对象，包含type和params属性
  if (e.type === 'success') {
    // 单选模式下，e.params是单个用户对象
    this.form.user_id = e.params.user_id;
    this.user = e.params;
  }
  this.isOpenUser = false;
},
    
    /*房产选择变化*/
    onRealEstateChange(realEstateId) {
      // 可以根据选择的房产自动填充一些信息
      const selectedRealEstate = this.realEstateList.find(item => item.real_estate_id == realEstateId);
      if (selectedRealEstate) {
        // 可以在这里设置一些默认值
      }
    },

    /*关闭弹窗*/
    dialogFormVisible(result) {
      this.$emit("close", { openDialog: false, "type": "" });
    },
    
    cancelFunc() {
      this.dialogFormVisible("error");
    },

    chooseCategory(){
      this.iscategorya = true;
    },

    getDetail() {
      let self = this;
      // 取到路由带过来的参数
      Fc_userApi.detail({fc_user_id: self.fc_user_id},true).then(res => {
          self.form = res.data;
           self.user = res.data.user;
          self.ueditor.text = self.form.intro;
          self.isImg = true
          self.loading = false;
          if(!self.form.bannar){
            self.form.bannar = [];
          }
          if(!self.form.image){
            self.form.image = [];
          }
        })
        .catch(error => {});
    },
    onSubmit() {
      let self = this;
      let form = self.form;
      // if(!form.categorya.categorya_id){
      //   self.$message({
      //           message:"请选择全分类",
      //           type: 'error'
      //         });
      //         return;
      // }
      // if(form.image.length <=0){
      //   self.$message({
      //           message:"请上传图片",
      //           type: 'error'
      //         });
      //         return;
      // }
      form.fc_user_id = self.fc_user_id;
      // form.intro = this.$refs.ue.getUEContent();
      self.$refs.form.validate(valid => {
        if (valid) {
          self.loading = true;
          Fc_userApi.edit(form, true)
            .then(data => {
              self.loading = false;
              self.$message({
                message: data.msg,
                type: 'success'
              });
              self.dialogFormVisible("error")
            })
            .catch(error => {
              self.loading = false;
            });
        }
      });
    },

    /*取消修改，返回任务列表*/
    cancelFunc() {
      this.$emit("close", { openDialog: false,"type":"" });
    },
    openProductUpload: function (code) {
      this.isProductUpload = true;
      this.code = code
    },

  
    /*上传商品图片*/
    returnProductImgsFunc(e) {
      // 1. 处理 e 为 null/undefined/非数组的情况，避免报错
      if (!e || !Array.isArray(e) || e.length === 0) {
        this.isProductUpload = false; // 关闭上传弹窗
        return; // 终止后续代码
      }

      // 2. 图片格式验证（优化逻辑，避免重复判断）
      const validImgTypes = ["bmp", "jpg", "jpeg", "png", "gif"];
      let isAllImgValid = true;

      e.forEach((element) => {
        // 获取文件后缀（转小写，避免大小写问题）
        const fileExt = element.file_path.split(".").pop().toLowerCase();
        // 若有一个文件格式无效，标记为整体无效
        if (!validImgTypes.includes(fileExt)) {
          isAllImgValid = false;
        }
      });

      // 3. 格式无效时提示并终止
      if (!isAllImgValid) {
        this.$message.error("图片格式有误，请选择 bmp/jpg/jpeg/png/gif 格式");
        this.isProductUpload = false;
        return;
      }

      // 4. 根据 code 存入对应的表单字段（关键修复：匹配证明材料字段）
      switch (this.code) {
        case "property_certificate": // 工作证照片
          // 合并已有图片和新上传图片（避免覆盖）
          this.form.property_certificate = [...this.form.property_certificate, ...e];
          break;
        case "payment_receipt": // 缴费单照片
          this.form.payment_receipt = [...this.form.payment_receipt, ...e];
          break;
        default:
          this.$message.warning("未知的图片上传类型");
      }

      // 5. 关闭上传弹窗
      this.isProductUpload = false;
    },

    /*删除商品图片*/
    deleteImg(index,code) {
      if(code == 'album'){
        this.form.image.splice(index, 1);
      }else if(code == 'bannar'){
        this.form.bannar.splice(index, 1);
      }
      
    },
  }
};
</script>

<style>
.edit_container {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

.ql-editor {
  height: 400px;
}



.draggable-list {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  flex-wrap: wrap;
}

.draggable-list .wrapper > span {
  display: flex;
  justify-content: flex-start;
  flex-wrap: wrap;
}

.draggable-list .item {
  position: relative;
  width: 110px;
  height: 110px;
  margin-top: 10px;
  margin-right: 10px;
  border-radius: 8px;
  overflow: hidden;
  border: 1px solid #dddddd;
}

.draggable-list .delete-btn {
  position: absolute;
  top: 0;
  right: 0;
  width: 16px;
  height: 16px;
  background: red;
  line-height: 16px;
  font-size: 16px;
  color: #ffffff;
  display: none;
}

.draggable-list .item:hover .delete-btn {
  display: block;
}

.draggable-list .item img {
  position: absolute;
  top: 50%;
  left: 50%;
  -webkit-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
  max-height: 100%;
  max-width: 100%;
}

.draggable-list .img-select {
  display: flex;
  justify-content: center;
  align-items: center;
  border: 1px dashed #dddddd;
  font-size: 30px;
}

.draggable-list .img-select i {
  color: #409eff;
}
</style>



// WEBPACK FOOTER //
// src/views/plus/fc_user/index/part/edit.vue